const PHRASES = [
    "Craft better programs",
    "Plan deeper sessions",
    "Achieving all goals",
    "Technology with craft",
    "Grow your practice",
    "Teach. Build. Power.",
];

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-[#E2E8F4] bg-sand py-6"
    >
        <div className="marquee-track flex w-max items-center">
            {[0, 1].map((copy) => (
                <div key={copy} aria-hidden={copy === 1} className="flex items-center">
                    {PHRASES.map((phrase) => (
                        <span key={`${copy}-${phrase}`} className="flex items-center">
                            <span className="whitespace-nowrap font-serif text-xl italic text-ink/70 sm:text-2xl">
                                {phrase}
                            </span>
                            <span className="mx-16 font-serif text-ember">✦</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
